import React from 'react';
import { FiservCard, FiservCardInterface } from '@common-fe/common-fe';

import { useOrganizationOverridableProperties } from '@/modules/core/hooks/useOrganizationOverridableProperties';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

import { CardItemWrapper } from './ChangeStatusCardModal.styles';

interface CardModalWrapperProps {
  card: FiservCardInterface;
  isLoading: boolean;
}

const CardModalWrapper: React.FC<CardModalWrapperProps> = ({ card, isLoading }) => {
  const { observingOrganizationData } = useOrganizationOverridableProperties();

  if (!card) {
    return null;
  }

  return (
    <CardItemWrapper $isFlipDisabled margin={{ top: '-135px', bottom: 'l' }}>
      <FiservCard
        card={card}
        logos={{
          logoUrl: observingOrganizationData?.logoInfo?.darkLargeLogoUrl,
          cardLogo: whiteLabelingConfig?.images?.cardLogo,
          defaultCardLogo: whiteLabelingConfig?.logo,
          cardBackground: whiteLabelingConfig?.images?.cardBackground,
        }}
        isActive
        isLoading={isLoading}
        supportsTwoSides
        wrapperStyle={{
          width: '480px',
        }}
      />
    </CardItemWrapper>
  );
};

export default CardModalWrapper;
